import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UtilitiesModule } from '@fi-app/utilities/utilities.module';
import { FranchiseIntranetUpgradeViewComponent } from './franchise-intranet-upgrade-view/franchise-intranet-upgrade-view.component';
import { FranchiseIntranetUpgradeService } from './franchise-intranet-upgrade.service';
import { FiEditorPageModule } from '@fi-app/components/fi-editor-page/fi-editor-page.module';
import { FormsModule } from '@angular/forms';
import { FiFranchiseIntranetUpgradeEditComponent } from './franchise-intranet-upgrade-edit/franchise-intranet-upgrade-edit.component';
import { FiTimePickerPopupModule } from '@fi-app/components/time-picker-popup/time-picker-popup.module';
import { FiFranchiseIntranetUpgradeListComponent } from './franchise-intranet-upgrade-list/franchise-intranet-upgrade-list.component';
import { ItemsListModule } from '@fi-app/components/items-list/items-list.module';
import { FiAppTextSharedModule } from '@fi-shared/app-text';
import { FiFranchiseIntranetUpgradeListDataService } from './franchise-intranet-upgrade-list/franchise-intranet-upgrade-list-data.service';
import { UIRouterModule } from '@uirouter/angular';
import { FranchiseIntranetUpgradeStates } from '@fi-app/franchise-intranet-upgrade/franchise-intranet-upgrade-states';
import { MatCardModule } from '@angular/material/card';
import { SelectSearchModule } from '@fi-shared/fi-select-search/select-search.module';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { FiPageHeaderModule } from '@fi-app/components/fi-page-header/fi-page-header.module';
import { FiPageHeaderButtonGroupModule } from '@fi-shared/fi-page-header-button-group/fi-page-header-button-group.module';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

@NgModule({
    imports: [
        CommonModule,
        UtilitiesModule,
        FiEditorPageModule,
        FormsModule,
        FiTimePickerPopupModule,
        ItemsListModule,
        FiAppTextSharedModule,
        UIRouterModule.forChild(FranchiseIntranetUpgradeStates),
        MatCardModule,
        SelectSearchModule,
        MatFormFieldModule,
        MatInputModule,
        FiPageHeaderModule,
        FiPageHeaderButtonGroupModule,
        MatButtonModule,
        MatIconModule,
    ],
    declarations: [
        FranchiseIntranetUpgradeViewComponent,
        FiFranchiseIntranetUpgradeEditComponent,
        FiFranchiseIntranetUpgradeListComponent,
    ],
    exports: [
        FranchiseIntranetUpgradeViewComponent,
        FiFranchiseIntranetUpgradeEditComponent,
        FiFranchiseIntranetUpgradeListComponent,
    ],
    providers: [FranchiseIntranetUpgradeService, FiFranchiseIntranetUpgradeListDataService],
})
export class FranchiseIntranetUpgradeModule {}
